import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('idle');
    setFormError('');

    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }

    try {
      const formData = new FormData(form);
      formData.delete('website_alt');
      const response = await fetch('https://readdy.ai/api/form/d9osdfqqs38sj6jc7ejg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (typeof serverMsg === 'string' && serverMsg.includes('spam')) {
          setFormStatus('error');
          setFormError('提交失败，请稍后重试');
        } else {
          setFormStatus('error');
          setFormError(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试');
        }
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <main>
      <article>
        <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url(https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20Chinese%20reading%20room%20with%20bookshelves%20filled%20with%20manga%20and%20comics%2C%20soft%20warm%20lighting%2C%20comfortable%20seating%2C%20peaceful%20atmosphere%2C%20cinematic%20wide%20composition%2C%20high%20quality%20photography&width=1600&height=700&seq=about-hero-01&orientation=landscape)`,
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
          <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 w-full">
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3">关于女神漫画网</h1>
            <p className="text-sm md:text-base text-background-200/90 max-w-lg">用心打造最好的中文漫画阅读平台</p>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-[1280px] mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>

            <div className="max-w-4xl mx-auto">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">品牌故事</h2>
              <div className="text-foreground-700 leading-relaxed space-y-4 text-sm md:text-base">
                <p>
                  女神漫画网成立于2020年，是国内领先的<strong>蜜桃少年漫画在线免费阅读平台</strong>。我们致力于为广大漫画爱好者提供<strong>高清漫画全集免费阅读下拉式</strong>服务，让每一位读者都能享受到便捷、流畅的阅读体验。
                </p>
                <p>
                  平台汇聚了海量优质漫画资源，涵盖<strong>少年漫画、恋爱漫画、热血漫画、玄幻漫画</strong>等多种类型。无论你喜欢什么样的漫画风格，都能在女神漫画网找到心仪的作品。
                </p>
                <p>
                  我们始终坚持&ldquo;<strong>以读者为中心</strong>&rdquo;的理念，不断优化阅读体验。下拉式阅读模式让您告别繁琐的翻页操作，高清画质呈现每一个精彩细节，真正做到沉浸式漫画阅读。
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mt-10">
                <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4">
                    <i className="ri-book-read-line text-2xl"></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900">海量资源</h3>
                  <p className="text-sm text-foreground-600 mt-2">超过5000部正版漫画，每日持续更新</p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4">
                    <i className="ri-hd-line text-2xl"></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900">高清画质</h3>
                  <p className="text-sm text-foreground-600 mt-2">全部漫画高清呈现，细节清晰可见</p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 text-center border border-background-200/70">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mb-4">
                    <i className="ri-smartphone-line text-2xl"></i>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900">多端适配</h3>
                  <p className="text-sm text-foreground-600 mt-2">电脑手机平板，随时随地畅享阅读</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-[1280px] mx-auto">
            <div className="max-w-4xl mx-auto">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">读者口碑</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    &ldquo;女神漫画网的蜜桃少年漫画真的太好看了！高清画质加上流畅的下拉式阅读，完全沉浸在其中。每天都要来看看有没有更新，已经成为我生活中不可或缺的一部分。&rdquo;
                  </p>
                  <p className="text-xs text-foreground-500 mt-3">— 漫画爱好者 小王</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    &ldquo;一直在找能免费看高清漫画的地方，女神漫画网完美满足了我的需求。长安幻夜画风太美了，下拉式阅读体验丝滑流畅，强烈推荐！&rdquo;
                  </p>
                  <p className="text-xs text-foreground-500 mt-3">— 古风迷 小李</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    &ldquo;作为一个漫画老读者，女神漫画网的资源库真的让我惊喜。分类清晰，找漫画超方便。龙族传说简直是我的最爱，每周都在追更新！&rdquo;
                  </p>
                  <p className="text-xs text-foreground-500 mt-3">— 老读者 张先生</p>
                </div>
                <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    &ldquo;朋友推荐的女神漫画网，从此打开新世界大门。花间少年的校园恋爱故事太甜了，高清画质每一帧都想截图保存。感谢平台提供这么好的阅读体验！&rdquo;
                  </p>
                  <p className="text-xs text-foreground-500 mt-3">— 新读者 小陈</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-[1280px] mx-auto">
            <div className="max-w-4xl mx-auto">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">联系我们</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                <div>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 flex-shrink-0">
                        <i className="ri-mail-line"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900">电子邮箱</h3>
                        <p className="text-sm text-foreground-600">contact@nvshenmanhua.com</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500 flex-shrink-0">
                        <i className="ri-qq-line"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900">客服QQ</h3>
                        <p className="text-sm text-foreground-600">1234567890</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-500 flex-shrink-0">
                        <i className="ri-time-line"></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-900">工作时间</h3>
                        <p className="text-sm text-foreground-600">周一至周日 9:00 - 21:00</p>
                      </div>
                    </div>
                  </div>

                  <div className="mt-6">
                    <h3 className="text-sm font-semibold text-foreground-900 mb-3">关注我们</h3>
                    <div className="flex items-center gap-3">
                      <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信">
                        <i className="ri-wechat-line"></i>
                      </a>
                      <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博">
                        <i className="ri-weibo-line"></i>
                      </a>
                      <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="QQ">
                        <i className="ri-qq-line"></i>
                      </a>
                      <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="B站">
                        <i className="ri-bilibili-line"></i>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">意见反馈</h3>

                  <form onSubmit={handleSubmit} data-readdy-form="">
                    <input
                      type="text"
                      name="website_alt"
                      className="spam-guard"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                    <div className="space-y-3">
                      <div>
                        <label htmlFor="feedback-name" className="block text-sm font-medium text-foreground-700 mb-1">姓名</label>
                        <input
                          id="feedback-name"
                          name="name"
                          type="text"
                          required
                          className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div>
                        <label htmlFor="feedback-email" className="block text-sm font-medium text-foreground-700 mb-1">邮箱</label>
                        <input
                          id="feedback-email"
                          name="email"
                          type="email"
                          required
                          className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                          placeholder="请输入您的邮箱"
                        />
                      </div>
                      <div>
                        <label htmlFor="feedback-type" className="block text-sm font-medium text-foreground-700 mb-1">反馈类型</label>
                        <select
                          id="feedback-type"
                          name="feedback_type"
                          className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                        >
                          <option value="技术问题">技术问题反馈</option>
                          <option value="内容版权">内容版权申诉</option>
                          <option value="商务合作">商务合作咨询</option>
                          <option value="漫画投稿">漫画投稿申请</option>
                          <option value="其他">其他问题</option>
                        </select>
                      </div>
                      <div>
                        <label htmlFor="feedback-message" className="block text-sm font-medium text-foreground-700 mb-1">反馈内容</label>
                        <textarea
                          id="feedback-message"
                          name="message"
                          required
                          maxLength={500}
                          rows={4}
                          className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                          placeholder="请描述您的建议或问题（最多500字）"
                        />
                      </div>
                      <button
                        type="submit"
                        className="w-full px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
                      >
                        提交反馈
                      </button>
                    </div>

                    {formStatus === 'success' && (
                      <p className="mt-4 text-sm text-accent-600 bg-accent-50 px-4 py-2 rounded-lg">感谢您的反馈，我们会在24小时内回复您！</p>
                    )}
                    {formStatus === 'error' && (
                      <p className="mt-4 text-sm text-red-600 bg-red-50 px-4 py-2 rounded-lg">{formError}</p>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </article>
    </main>
  );
}